import { render, staticRenderFns } from "./Nobb.vue?vue&type=template&id=5630bfc0"
import script from "./Nobb.vue?vue&type=script&lang=js"
export * from "./Nobb.vue?vue&type=script&lang=js"
import style0 from "./Nobb.vue?vue&type=style&index=0&id=5630bfc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports